import {AnalyzeIdDocumentFailureCodes} from 'src/cassandra'
import {OnCameraCompleteCallback} from 'src/products/general/components/organisms/CameraPage/CameraPage'

export enum IDScanCapturePhases {
  ImageCapture,
  ImageCaptured,
}

export enum IDScanProcessingStatuses {
  Processing,
  Complete,
}

export type IDScanProps = {
  onImageSubmitStart: () => void
  onImageSubmitComplete: OnCameraCompleteCallback
  onContinue: () => Promise<void>
  busy: boolean
  phase: IDScanCapturePhases
  error?: AnalyzeIdDocumentFailureCodes
  clearErrors?: () => void
  processingStatus?: IDScanProcessingStatuses
}
